import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'topology-viewer',
});

export const builderRouteRef = createRouteRef({
  id: 'topology-viewer-builder',
});

export const gesBuilderRouteRef = createRouteRef({
  id: 'ges-builder',
});
